import type { RegexPattern } from '../types';

/**
 * @group Constants
 * @summary <blockquote>Regex patterns for parsing GitHub issue comments and responses.</blockquote>
 * 
 * Patterns used to extract structured data from GitHub comment text.
 */
export const GITHUB_PARSING_PATTERNS = {
  /**
   * Parses GitHub issue comment responses in format: "Q1: answer" or "1. answer"
   * Supports multi-line answers and handles various formatting styles
   */
  QUESTION_RESPONSE_FORMAT_1: {
    regex: /(?:^|\n)\s*(?:Q)?(\d+)[.:]\s*(.+?)(?=\n\s*(?:Q)?\d+[.:]|$)/gs,
    description: 'Parses GitHub issue comment responses in format: "Q1: answer" or "1. answer"',
    examples: ['Q1: Yes', '1. No', '2: Maybe'],
    counterExamples: ['Question 1: answer', 'Q1 answer', '1 answer'],
  } as RegexPattern,

  /**
   * Parses GitHub issue comment responses in format: "Q1 answer" or "1 answer"
   * Alternative format without colons or periods
   */
  QUESTION_RESPONSE_FORMAT_2: {
    regex: /(?:^|\n)\s*(?:Q)?(\d+)\s+(.+?)(?=\n\s*(?:Q)?\d+\s+|$)/gs,
    description: 'Parses GitHub issue comment responses in format: "Q1 answer" or "1 answer"',
    examples: ['Q1 Yes', '1 No', '2 Maybe'],
    counterExamples: ['Q1: answer', '1. answer', 'Question 1 answer'],
  } as RegexPattern,
} as const;
